const betRadarLocales = {
  'en-GB':'en',
  'es-ES':'es',
  'in-ID':'id',
  'pt-BR':'pt',
  'vi-VN':'vi',
  'hi-IN':'hi',
  'th-TH':'th',
  'zh-CN':'zh',
  'ja-JP':'ja',
  'zh-TW':'zht',
  'ko-KR':'ko',
  'te-IN':'en',
  'el':'el'
};
function initEventPageLMTWidget(locale) {
  (function(a,b,c,d,e,f,g,h,i){a[e]||(i=a[e]=function(){(a[e].q=a[e].q||[]).push(arguments)},i.l=1*new Date,i.o=f,
      g=b.createElement(c),h=b.getElementsByTagName(c)[0],g.async=1,g.src=d,g.setAttribute("n",e),h.parentNode.insertBefore(g,h)
  )})(window,document,"script", "https://widgets.sir.sportradar.com/25ba028d902b018fc2dc915fc5385962/widgetloader", "SIR", {
    theme: false, // using custom theme
    language: (typeof  betRadarLocales[locale] !=='undefined'? betRadarLocales[locale]:'en')
  });
}
function initLiveCenterLMTPitchWidget() {

}
function initLiveCenterLMTStatisticsWidget() {

}
function initMobileEventPageLMTWidget(locale) {
  (function(a,b,c,d,e,f,g,h,i){a[e]||(i=a[e]=function(){(a[e].q=a[e].q||[]).push(arguments)},i.l=1*new Date,i.o=f,
      g=b.createElement(c),h=b.getElementsByTagName(c)[0],g.async=1,g.src=d,g.setAttribute("n",e),h.parentNode.insertBefore(g,h)
  )})(window,document,"script", "https://widgets.sir.sportradar.com/kryptium/widgetloader", "SIR", {
    theme: false, // using custom theme
    language: (betRadarLocales.findIndex((entry)=>entry===locale)!== -1? locale:'en')
  });
}
export default {
  initEventPageLMTWidget:initEventPageLMTWidget,
  initMobileEventPageLMTWidget
}
